<!-- メイン -->
<div class="main">
  <div class="main-content">
    <div class="p-fluid p-formgrid p-grid search-screen">
      <div class="p-col-12">
        <div class="p-fluid p-formgrid p-grid search-screen-col grid">
          <div class="p-col-3 p-lg-3 p-md-3 p-xl-3 p-flex-sm-nowrap side-left">
            <div class="p-fluid p-formgrid p-grid desktop">
              <div class="p-col-12">
                <form [formGroup]="c201SearchForm" (ngSubmit)="getResultTaskDataList(true)">
                  <div class="p-d-flex box-freeword">
                    <div class="input-icon-container">
                      <input type="text" pInputText class="freeword-inputtext" [formControl]="c201SearchForm.controls.freeword"/>
                      <i class="pi pi-search search-icon"></i>
                    </div>
                  </div>
                  <p-accordion [multiple]="true">
                    <p-accordionTab header="団体区分詳細" [disabled]="isDisabledTab('member_class_sub_id')"
                      [(selected)]="accordion_member_class_sub_id" aria-label="団体区分詳細">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(82),
                                  'member_class_sub_id'
                                )
                              ">すべて選択</a> </span>　|　
                          <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(82),
                                  'member_class_sub_id'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let dicData of getDicList(82)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls.member_class_sub_id
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="所在地(市区町村)" [disabled]="
                        isDisabledTab('member_municipalities')
                      " [(selected)]="accordion_member_municipalities" aria-label="所在地(市区町村)">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(2016),
                                  'member_municipalities'
                                )
                              ">すべて選択</a></span>　|　
                          <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(2016),
                                  'member_municipalities'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let dicData of getDicList(2016)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .member_municipalities
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="乳幼児の年齢" [disabled]="
                        isDisabledTab('agenda_need_target_grade')
                      " [(selected)]="accordion_agenda_need_target_grade" aria-label="乳幼児の年齢">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(5),
                                  'agenda_need_target_grade'
                                )
                              ">すべて選択</a></span>　|　
                          <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(5),
                                  'agenda_need_target_grade'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let dicData of getDicList(5)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .agenda_need_target_grade
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="実施場所" [disabled]="
                        isDisabledTab('agenda_need_desired_location')
                      " [(selected)]="accordion_agenda_need_desired_location" aria-label="実施場所">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(6),
                                  'agenda_need_desired_location'
                                )
                              ">すべて選択</a></span>　|　
                          <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(6),
                                  'agenda_need_desired_location'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let dicData of getDicList(6)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .agenda_need_desired_location
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="実施可能曜日" [disabled]="
                        isDisabledTab('agenda_need_desired_dayweek')
                      " [(selected)]="accordion_agenda_need_desired_dayweek" aria-label="実施可能曜日">
                      <div class="accrodion-form-list">
                        <div class="btn-check">
                          <span><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'checkAll',
                                  getDicList(7),
                                  'agenda_need_desired_dayweek'
                                )
                              ">すべて選択</a></span>　|　
                          <span class="p-ml-2"><a href="#" (click)="$event.preventDefault();
                                checkLargeCategory(
                                  'removeAll',
                                  getDicList(7),
                                  'agenda_need_desired_dayweek'
                                )
                              ">解除</a></span>
                        </div>
                        <div *ngFor="let dicData of getDicList(7)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .agenda_need_desired_dayweek
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>
                  </p-accordion>
                </form>
              </div>
              <div class="p-col-12 btn-block-search">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-12">
                    <button pButton type="button" label="検索" class="p-button-danger btn-search-item"
                      (click)="getResultTaskDataList(true)"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-fluid p-formgrid p-grid mobile">
              <div class="p-col-12">
                <form [formGroup]="c201SearchForm" (ngSubmit)="getResultTaskDataList(true)">
                  <div class="p-d-flex box-freeword">
                    <div class="input-icon-container">
                      <input type="text" pInputText class="freeword-inputtext" [formControl]="c201SearchForm.controls.freeword"/>
                      <i class="pi pi-search search-icon"></i>
                    </div>
                  </div>
                  <p-accordion [multiple]="true" expandIcon="pi pi-fw pi-plus" collapseIcon="pi pi-fw pi-minus">
                    <p-accordionTab header="団体区分詳細" [disabled]="isDisabledTab('member_class_sub_id')"
                      [(selected)]="accordion_member_class_sub_id" aria-label="団体区分詳細">
                      <div class="accrodion-form-list">

                        <div *ngFor="let dicData of getDicList(82)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls.member_class_sub_id
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="所在地(市区町村)" [disabled]="isDisabledTab('member_municipalities')"
                      [(selected)]="accordion_member_municipalities" aria-label="所在地(市区町村)">
                      <div class="accrodion-form-list">

                        <div *ngFor="let dicData of getDicList(2016)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .member_municipalities
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="乳幼児の年齢" [disabled]="isDisabledTab('agenda_need_target_grade')"
                      [(selected)]="accordion_agenda_need_target_grade" aria-label="乳幼児の年齢">
                      <div class="accrodion-form-list">

                        <div *ngFor="let dicData of getDicList(5)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .agenda_need_target_grade
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="実施場所" [disabled]="isDisabledTab('agenda_need_desired_location')"
                      [(selected)]="accordion_agenda_need_desired_location" aria-label="実施場所">
                      <div class="accrodion-form-list">

                        <div *ngFor="let dicData of getDicList(6)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .agenda_need_desired_location
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                    <p-accordionTab header="実施可能曜日" [disabled]="isDisabledTab('agenda_need_desired_dayweek')"
                      [(selected)]="accordion_agenda_need_desired_dayweek" aria-label="実施可能曜日">
                      <div class="accrodion-form-list">

                        <div *ngFor="let dicData of getDicList(7)">
                          <p-checkbox [label]="dicData.sp_name" [value]="dicData.sp_code" [formControl]="
                              c201SearchForm.controls
                                .agenda_need_desired_dayweek
                            "></p-checkbox>
                        </div>
                      </div>
                    </p-accordionTab>

                  </p-accordion>
                </form>
              </div>
              <div class="p-col-12 btn-block-search">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-12">
                    <button pButton type="button" label="検索" class="p-button-danger btn-search-item"
                      (click)="getResultTaskDataList(true)"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-8 item-search-detail">
            <div class="p-fluid p-formgrid p-grid detail-item">
              <div class="p-col-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="card">
                    <p-dataView #dv [value]="resultTaskDataList" [paginator]="true" [rows]="20" filterBy="name"
                      layout="grid" [sortField]="sortField" [sortOrder]="sortOrder">
                      <ng-template pTemplate="header">
                        <div class="flex flex-column md:flex-row md:justify-content-between">
                          <div class="p-fluid p-formgrid p-grid p-jc-between">
                            <div class="">
                              <span class="header-title-list-item primary-title">
                                保育所・幼稚園等のふれあい体験希望一覧
                              </span>
                            </div>
                            <ng-container *ngIf="class_id === '1'">
                              <ng-container *ngIf="modeMulti == true; else modeMultiple">
                                <div class="p-col-6 btn-mode-multi">
                                  <button pButton type="button" label="一括で申し込む" class="p-mr-2 border-none"
                                    (click)="confirmMulti()"></button>
                                  <button pButton type="button" label="キャンセル"
                                    class="p-button-raised bg-white-color btn-delete button2"
                                    (click)="changeModeMulti(false)"></button>
                                </div>
                              </ng-container>
                              <ng-template #modeMultiple>
                                <div class="p-col-6 btn-change-mode-multi">
                                  <button pButton type="button" label="複数選択" class="border-none"
                                    (click)="changeModeMulti(true)"></button>
                                </div>
                              </ng-template>
                            </ng-container>
                            <!-- <div class=" icon-view-data">
                              <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
                            </div> -->
                          </div>
                        </div>
                        <!-- 一覧画面ヘッダー表示-->
                        <ng-container *ngIf="dv.layout == 'list'">
                          <div class="dv-header-table-header">
                            <!-- dataViewヘッダー -->
                            <p-table styleClass="p-datatable-sm generate-input">
                              <!-- 一覧画面ヘッダー表示-->
                              <ng-template pTemplate="header">
                                <tr class="p-col-2">
                                  <!-- APIヘッダーの表示 -->
                                  <ng-container *ngFor="let column of columnOrder">
                                    <th [pSortableColumn]="column.field" (click)="onSortChange(column.field)">
                                      {{ column.header }}
                                      <p-sortIcon [field]="column.field"></p-sortIcon>
                                    </th>
                                  </ng-container>
                                </tr>
                              </ng-template>
                            </p-table>
                          </div>
                        </ng-container>
                      </ng-template>

                      <ng-template let-searchResults let-rowIndex="rowIndex" pTemplate="listItem">
                        <p-table #table [value]="[searchResults]" styleClass="p-table-striped order-table"
                          selectionMode="single" dataKey="delivery_id" expandableRows="true">
                          <!-- 一覧画面ボディ表示-->
                          <ng-template pTemplate="body">
                            <tr class="p-col-2">
                              <!-- チェックボックス -->

                              <ng-container *ngFor="let column of columnOrder; index as i" [ngSwitch]="true">
                                <!-- 一覧項目値表示(詳細画面遷移項目) -->
                                <td *ngIf="0 == i; else hideContent">
                                  <label class="pointer" (click)="
                                      moveC341(searchResults[column.field])
                                    ">
                                    <u>{{ searchResults[column.field] }}</u>
                                  </label>
                                </td>
                                <!-- 一覧項目値表示 -->
                                <ng-template #hideContent [ngSwitch]="column?.input_type">
                                  <td *ngSwitchCase="'NUMBER'" class="content-item"
                                    [pTooltip]="searchResults[column.field]" #tt [tooltipDisabled]="!isOverflow(tt)"
                                    showDelay="500" hideDelay="500" tooltipPosition="bottom">
                                    {{ searchResults[column.field] | number }}
                                  </td>
                                  <td *ngSwitchDefault class="content-item" [pTooltip]="searchResults[column.field]" #tt
                                    [tooltipDisabled]="!isOverflow(tt)" showDelay="500" hideDelay="500"
                                    tooltipPosition="bottom">
                                    {{ searchResults[column.field] }}
                                  </td>
                                </ng-template>
                              </ng-container>
                            </tr>
                          </ng-template>
                        </p-table>
                      </ng-template>
                      <ng-template let-resultTaskDataItem pTemplate="gridItem">
                        <div class="p-col-6 item-detail-row">
                          <div class="search-item-detail">
                            <ng-container *ngIf="modeMulti">
                              <div class="p-as-center p-pr-2">
                                <p-checkbox name="cartCheckBox" value="{{
                                    resultTaskDataItem.agenda_need_agenda_id
                                  }}" [(ngModel)]="cartSelected" aria-label="選択解除"></p-checkbox>
                              </div>
                            </ng-container>
                            <div class="search-img-item" (click)="
                                moveC341(
                                  resultTaskDataItem.agenda_need_agenda_id
                                )
                              ">
                              <img alt="アイコン画像" [src]="
                                  resultTaskDataItem.agenda_need_icon_image
                                " class="search-item-img" />
                            </div>
                            <div class="search-item-description" (click)="
                                moveC341(
                                  resultTaskDataItem.agenda_need_agenda_id
                                )
                              ">
                              <span class="func-name text-sub-size letter-spacing-1 pink-color-c231">{{
                                resultTaskDataItem.member_class_sub_id
                                }}
                              </span>
                              <ng-container *ngIf="
                                  resultTaskDataItem?.agenda_need_access_modifiers
                                ">
                                <div *ngIf="
                                    resultTaskDataItem?.agenda_need_access_modifiers ==
                                      1;
                                    else public
                                  " class="not-public p-jc-start">
                                  <i class="pi pi-lock"></i>
                                  <span>非公開</span>
                                </div>
                                <ng-template #public>
                                  <div class="public p-jc-start">
                                    <span>公開</span>
                                  </div>
                                </ng-template>
                              </ng-container>
                              <ng-container *ngIf="
                                  resultTaskDataItem.agenda_need_access_modifiers ===
                                  ''
                                ">
                                <h6 class="item-description-large" [pTooltip]="resultTaskDataItem?.member_municipalities + ' ' +
                                resultTaskDataItem?.member_organization_name" #tt [tooltipDisabled]="!isOverflow(tt)"
                                  showDelay="500" hideDelay="500" tooltipPosition="bottom">{{
                                  resultTaskDataItem?.member_municipalities + ' ' +
                                  resultTaskDataItem?.member_organization_name }}
                                </h6>
                              </ng-container>
                              <span class="item-sub-description">{{
                                resultTaskDataItem?.agenda_need_oneword_message
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-dataView>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Toastメッセージ表示 -->
<p-toast position="top-center"></p-toast>